import VatExplanation from './VatExplanation';

const company = {
  customerType: 'BUSINESS',
  legalName: 'Testi Oy',
  country: 'FI',
  postalCode: '00100',
  street: 'Testikatu 1',
  city: 'Helsinki',
  vatNumber: 'FI31503663',
  businessProofRef: '',
};
const base = {
  billing: company,
  formId: 'VatExplanationExample',
  onSaveBillingDetails: () => Promise.resolve(),
};

export const InvoiceVerified = {
  component: VatExplanation,
  props: { ...base, buyerValidation: 'VERIFIED', path: 'invoice' },
  group: 'payment methods',
};

export const CardUnverified = {
  component: VatExplanation,
  props: { ...base, buyerValidation: 'UNVERIFIED', path: 'stripe', isCardPayment: true },
  group: 'payment methods',
};

export const CardConsumer = {
  component: VatExplanation,
  props: {
    ...base,
    billing: { customerType: 'CONSUMER', country: 'FI', postalCode: '00100' },
    buyerValidation: 'NONE',
    path: 'stripe',
    isCardPayment: true,
  },
  group: 'payment methods',
};
